<div id="vorauswahlContainer">
  <menuVorauswahlToolbar [mandant]="mandant" [kunde]="kunde" [apiZeitraum]="apiZeitraum"></menuVorauswahlToolbar>
  <div id="vorauswahlTagListe">
    <ng-container *ngFor="let tag of apiMenuVorauswahlContent | keyvalue">
      <menuVorauswahlTag [tag]="tag.value" [mandant]="mandant" class="menuVorauswahlTag" *ngIf="kannTagDargestelltWerden(tag.value)"></menuVorauswahlTag>
    </ng-container>
  </div>
</div>
